export const ModuleFields = {
  id: 'id',
  caption: 'caption',
  viewId: 'viewId',
  moduleGroupId: 'moduleGroupId',
  type: 'type',
  icon: 'icon',
  sourceUrl: 'sourceUrl',
  position: 'position',
  removed: 'removed',
  forms: 'forms',
  roles: 'roles',
  hidden: 'hidden',
  displayInMobile: 'displayInMobile',
  target: 'target',
  showAllFormsFirst: 'showAllFormsFirst',
} as const;
export type ModuleFields = (typeof ModuleFields)[keyof typeof ModuleFields];
